(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-thrv-about-link]').forEach((link) => {
    if (link.dataset.thrvBound === 'true') return;
    link.dataset.thrvBound = 'true';
    link.addEventListener('click', (event) => {
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#')) return;
      const target = document.querySelector(href);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
    });
  });

  const items = document.querySelectorAll('[data-thrv-reveal]:not(.is-visible)');
  if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: .12, rootMargin: '0px 0px -5% 0px' });

  items.forEach((item) => observer.observe(item));
})();
